import { matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  shareBillPayVirtualCardRouteProps,
  VirtualCardDetailMatchParams,
} from 'src/navigation/routeProps'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectVirtualCardIdFromForegroundRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<VirtualCardDetailMatchParams>(
      location.pathname,
      shareBillPayVirtualCardRouteProps,
    )
    return mtch?.params?.id
  },
)
